var styleDataHash = "6bb31be4";
const injectCss = (() => {
  var css = `.zLC2q{background-color:var(--vertical-embed-background-color,var(--ricos-custom-vertical-embed-background-color,transparent));border:var(--vertical-embed-border-width,1px) solid var(--vertical-embed-border-color,var(--ricos-custom-vertical-embed-border-color,rgba(0,0,0,.2)));border-radius:var(--vertical-embed-border-radius,0);container-type:inline-size;cursor:pointer;display:flex;overflow:hidden;transition:all .2s ease-in-out;width:100%}.cOStX{min-height:98px;min-width:80px}.DzpE6,.cOStX{align-items:center;display:flex;justify-content:center;width:100%}.DzpE6{gap:18px;min-height:120px;min-width:0;overflow:hidden;padding:var(--vertical-embed-content-padding)}.DzpE6,.qZNg6{flex-direction:column;height:100%;text-align:center}.qZNg6{padding:20px}.V4ByW,.qZNg6{align-items:center;display:flex;justify-content:center}.V4ByW{background-color:#e62214;border-radius:50%;height:30px;width:30px}._8Va4y{gap:12px}.-eaOO,._8Va4y{align-items:center;display:flex}.-eaOO{flex-direction:row;justify-content:space-between;width:100%}.fb7lv{container-type:inline-size;position:relative;width:100%;z-index:20}@supports not (contain:inline-size){@media only screen and (max-width:478px){.fb7lv .-eaOO{flex-direction:column;gap:18px}.fb7lv ._8Va4y{flex-direction:column;text-align:center}}}@container (width < 478px){.fb7lv .-eaOO{flex-direction:column;gap:18px}.fb7lv ._8Va4y{flex-direction:column;text-align:center}}.ciYnJ{margin-inline-end:8px}.yAjYJ{margin-bottom:16px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var component_default = {
  "card": "zLC2q",
  "container": "cOStX",
  "content": "DzpE6",
  "errorOverlay": "qZNg6",
  "errorIcon": "V4ByW",
  "errorInfo": "_8Va4y",
  "errorContainer": "-eaOO",
  "overlay": "fb7lv",
  "errorIconInner": "ciYnJ",
  "errorSubtitle": "yAjYJ"
};
export {
  component_default as default,
  injectCss
};
//# sourceMappingURL=component-scss.js.map
